// Sessions view component for displaying the list of test sessions

import { SessionsViewProps } from '../types';

export function SessionsView(props: SessionsViewProps, container: HTMLElement): void {
  const { sessionStates, activeSessionLabel, onSessionSelect } = props;
  const sessionLabels = Object.keys(sessionStates);
  
  // Clear container
  container.innerHTML = '';
  
  if (sessionLabels.length === 0) {
    container.innerHTML = `
      <div class="msdr-sidebar-header">
        Test Sessions
        <span class="msdr-session-count">0 sessions</span>
      </div>
      <div class="msdr-empty-state">
        <div class="msdr-icon">📝</div>
        <h3>No Sessions Defined</h3>
        <p>Define test sessions to get started</p>
      </div>
    `;
    return;
  }
  
  // Create header
  const header = document.createElement('div');
  header.className = 'msdr-sidebar-header';
  header.innerHTML = `
    Test Sessions
    <span class="msdr-session-count">${sessionLabels.length} sessions</span>
  `;
  container.appendChild(header);
  
  // Create session list container
  const sessionList = document.createElement('div');
  sessionList.className = 'msdr-session-list';
  
  sessionLabels.forEach(label => {
    const state = sessionStates[label];
    const isActive = label === activeSessionLabel;
    
    const sessionItem = document.createElement('div');
    sessionItem.className = `msdr-session-item ${isActive ? 'active' : ''}`;
    sessionItem.addEventListener('click', () => onSessionSelect(label));
    
    const sessionInfo = document.createElement('div');
    sessionInfo.className = 'msdr-session-info';
    
    const sessionName = document.createElement('div');
    sessionName.className = 'msdr-session-name';
    sessionName.textContent = label;
    
    const sessionMeta = document.createElement('div');
    sessionMeta.className = 'msdr-session-meta';
    sessionMeta.textContent = 'Test session';
    
    sessionInfo.appendChild(sessionName);
    sessionInfo.appendChild(sessionMeta);
    
    const sessionStatus = document.createElement('div');
    sessionStatus.className = 'msdr-session-status';
    
    const statusBadge = document.createElement('div');
    statusBadge.className = `msdr-status-badge ${state.status}`;
    statusBadge.textContent = capitalize(state.status);
    
    sessionStatus.appendChild(statusBadge);
    
    if (state.stats) {
      const sessionStats = document.createElement('div');
      sessionStats.className = 'msdr-session-stats';
      sessionStats.textContent = `${state.stats.passes}✓ ${state.stats.failures}✗ ${state.stats.tests}T`;
      sessionStatus.appendChild(sessionStats);
    }
    
    sessionItem.appendChild(sessionInfo);
    sessionItem.appendChild(sessionStatus);
    sessionList.appendChild(sessionItem);
  });
  
  container.appendChild(sessionList);
}

function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
